export const vertexShader = `
    attribute vec3  customColor;
    attribute float customOpacity;
    attribute float customSize;
    attribute float customAngle;
    attribute float customVisible;  
    uniform float heightOfNearPlane;
    
    
    varying vec4  vColor;
    varying float vAngle;
    void main()
    {
        if ( customVisible > 0.5 ) 				
            vColor = vec4( customColor, customOpacity ); 
        else							
            vColor = vec4(0.0, 0.0, 0.0, 0.0);		
            
        vAngle = customAngle;

        vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );
        //gl_PointSize = customSize * ( 300.0 / length( mvPosition.xyz ) );     
        gl_Position = projectionMatrix * mvPosition;
        gl_PointSize = ( heightOfNearPlane * customSize ) / gl_Position.w;
        
        
    }
` 

export const fragmentShader = `
    uniform sampler2D u_sampler;
    varying vec4 vColor;	
    varying float vAngle;  
    void main()
    {
        gl_FragColor = vColor;
        
        float c = cos(vAngle);
        float s = sin(vAngle);
        vec2 rotatedUV = vec2(c * (gl_PointCoord.x - 0.5) + s * (gl_PointCoord.y - 0.5) + 0.5, c * (gl_PointCoord.y - 0.5) - s * (gl_PointCoord.x - 0.5) + 0.5);  
        vec4 rotatedTexture = texture2D( u_sampler,  rotatedUV );
        gl_FragColor = gl_FragColor * rotatedTexture;   
    }
`